<template>
    <div class="backdrop" @click.self="closeModal">
        <div id="twoColumnModalContent">
            <div id="body">
                <div class="block" style="text-align:right;margin-bottom: 0;" @click="closeModal">
                  <b-button type="is-primary" outlined rounded >Close</b-button>
                </div>

                <template>
                    <img id="signInModalLogo"
                         :src="require('@/assets/images/direct-sign-logo.png')"
                         alt="Lightweight UI components for Vue.js based on Bulma"
                    >
                    <div id="signInModalBodyTopic">
                        <h3>Sign Up on DirectSign to make your<br/>Sign work easy!</h3>
                        <p id="smallText">Enter below details to create your account and proceed.</p>
                    </div>

                    <div class="columns">
                        <div class="column"></div>
                        <div class="column is-two-thirds">
                            <div class="box-1" style="height: 105%; margin-top: -2%">

                                <div class="mt-5">

                                    <b-field

                                            :type="fieldValidation.fullName == ''? 'is-info' : 'is-danger'"
                                            :message="fieldValidation.fullName"
                                            label="Enter Your Full Name"
                                            label-position="on-border"
                                            style="padding-bottom: 10px;"
                                    >
                                        <b-input
                                                v-model="fullName"
                                                class="signInFormField"
                                                @input="resetInvalidFields('fullName')"
                                                placeholder="Cameron Williamson"
                                                rounded
                                        ></b-input>
                                    </b-field>

                                    <b-field

                                            :type="fieldValidation.nicNumber == ''? 'is-info' : 'is-danger'"
                                            :message="fieldValidation.nicNumber"
                                            label="Enter Your NIC Number"
                                            label-position="on-border"
                                            style="padding-bottom: 10px;"
                                    >
                                        <b-input
                                                v-model="nicNumber"
                                                class="signInFormField"
                                                @input="resetInvalidFields('nicNumber')"
                                                placeholder="962554870v"
                                                rounded
                                        ></b-input>
                                    </b-field>

                                    <b-field

                                            :type="fieldValidation.contactNumber == ''? 'is-info' : 'is-danger'"
                                            :message="fieldValidation.contactNumber"
                                            label="Enter Your Contact Number"
                                            label-position="on-border"
                                            style="padding-bottom: 10px;"
                                    >
                                        <b-input
                                                v-model="contactNumber"
                                                class="signInFormField"
                                                @input="resetInvalidFields('contactNumber')"
                                                placeholder="0771212121"
                                                rounded
                                        ></b-input>
                                    </b-field>

                                    <b-field

                                            :type="fieldValidation.email == ''? 'is-info' : 'is-danger'"
                                            :message="fieldValidation.email"
                                            label="Enter Your Email"
                                            label-position="on-border"
                                            style="padding-bottom: 10px;"
                                    >
                                        <b-input
                                                v-model="email"
                                                class="signInFormField"
                                                @input="resetInvalidFields('email')"
                                                placeholder="Jasoncarter@gmail.com"
                                                rounded
                                        ></b-input>
                                    </b-field>


                                    <div class="buttons">
                                        <b-button type="is-primary" outlined rounded expanded :loading="isSubmiting"  @click="submitFields">Next</b-button>
                                    </div>
                                    <div>
                                    <p>
                                        Already Have an Account?
                                    </p>
                                    <div class="buttons">
                                        <b-button type="is-primary" outlined rounded expanded  @click="goToSignIn">Sign In</b-button>
                                    </div>
                                </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data(){
            return{
                // use to store input field validation status
                fieldValidation:{
                    fullName: "",
                    nicNumber : "",
                    contactNumber : "",
                    email : "",
                },

                // variables to store field inputs
                fullName:'',
                nicNumber: '',
                contactNumber: '',
                email: '',
                nic_type: '',
                isSubmiting:false,

                regex:{
                    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    customer_nic_old: /^([0-9]{9}[vVxX]{1})$/,
                    // customer_nic_new: /^([0-9]{12})$/,
                    customer_nic_new:/^[0-9]{7}[0][0-9]{4}$/,
                    nic:/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/,
                    full_name: /^[a-zA-Z][a-zA-Z ]{1,127}$/,
                    // contact: /^[0-9]{10}$/,
                    contact:/^(?:0|94|\+94)7(0|1|2|4|5|6|7|8)\d\d{6}$/
                },
            }
        },
        props:{
            'headingArea' :{
                default : true
            },
        },
        components:{

        },

        methods:{
            closeModal:function(){
                this.$emit('close')
            },

            goToSignIn : function(){
            console.log("goToSignInPage")
            this.$emit('goToSignInPage')
           },
            // method to validate the input fields
            validateFiedls:function (){
                var formIsValid = true

                if(this.fullName === '' ){
                    console.log("Invalid fullname")
                    this.fieldValidation.fullName = 'Full name cannot be empty'
                    formIsValid = false
                }
                else if(!this.regex.full_name.test(this.fullName)){
                    this.fieldValidation.fullName  = 'Please enter valid full name'
                    formIsValid = false
                }

                // if(this.nicNumber === ''){
                //     console.log("Invalid NIC")
                //     this.fieldValidation.nicNumber = 'NIC cannot be empty'
                // }
                // else if((!this.regex.customer_nic_old.test(this.nicNumber) && !this.regex.customer_nic_new.test(this.nicNumber) ) ){
                //     this.fieldValidation.nicNumber = 'Only allowed old and new NIC formats'
                //     formIsValid = false
                // }

              // Return today's date and time
              var currentTime = new Date()
              var year = currentTime.getFullYear()
              var age

              //nic
              if(this.nicNumber =='' || this.nicNumber.indexOf(' ') >= 0){
                this.fieldValidation.nicNumber = 'NIC cannot be empty'
                formIsValid = false
              }
              else if(!this.regex.nic.test(this.nicNumber)){
                this.fieldValidation.nicNumber = 'Please enter valid NIC'
                formIsValid = false
              }else{
                //check old nic
                if(this.nicNumber.length == 10){
                  console.log('old nic')
                  var digits = this.nicNumber.substring(0,2)
                  const BirthYear = Number("19"+digits);
                  age  = year-BirthYear;
                  if(age > 80){
                    this.fieldValidation.nicNumber = 'Please enter valid NIC'
                    formIsValid = false
                  }

                }else if(this.nicNumber.length == 12){  //check new nic
                  var fourdigits = this.nicNumber.substring(0,4)
                  age  = year-fourdigits;
                  if(age > 80){
                    this.fieldValidation.nicNumber  = 'Please enter valid NIC'
                    formIsValid = false
                  }
                }
              }

                if(this.email === '' ){
                    this.fieldValidation.email = 'Email cannot be empty'
                    formIsValid = false
                }
                else if(!this.regex.email.test(this.email)){
                    this.fieldValidation.email  = 'Please enter valid email address'
                    formIsValid = false
                }

                if(this.contactNumber === '' ){
                    this.fieldValidation.contactNumber = 'Contact number cannot be empty'
                    formIsValid = false
                }
                else if(!this.regex.contact.test(this.contactNumber)){
                    this.fieldValidation.contactNumber  = 'Please enter valid contact number'
                    formIsValid = false
                }

                if(formIsValid){
                    return true
                }
                else{
                    return false
                }
            },

            submitFields : function(){
                if(this.validateFiedls()){
                    this.isSubmiting = true
                    console.log("Sign up Fields are valid")
                    this.$root.customerData.name = this.fullName
                    this.$root.customerData.nicNumber = this.nicNumber
                    this.$root.customerData.email = this.email
                    this.$root.customerData.contactNumber = this.contactNumber

                    if(this.$root.customerData.nicNumber.length == 10){
                        this.nic_type = 'old-nic'
                        this.$root.customerData.nic_type = this.nic_type
                    }
                    else {
                        this.nic_type = 'new-nic'
                        this.$root.customerData.nic_type = this.nic_type
                    }

                    setTimeout(()=>{
                      this.$emit('successCustomerSignedUp')
                      this.isSubmiting = false
                    },3000)

                }
                else{
                    console.log("Sign in Fields are invalid")
                }
            },

            resetInvalidFields : function(field){
                this.fieldValidation[field] =''
            },
        }


    }

</script>

<style scoped>
    #twoColumnModalContent{
        /*margin: 10% auto;*/
        width: 800px;
        background: white;
        border-radius: 20px;
        min-height: 100px;
        padding: 20px;
        line-height: normal;
        overflow-y: scroll;
        margin-top: 5%;
        margin-left: 5%;
        margin-right: 5%;
        margin-bottom: 5%;

    }
    .backdrop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        justify-content: center;
        display: flex;

    }

    #signInModalLogo{
        width: 10%;
        margin-bottom: 25px;
    }

    #signInModalBodyTopic > h3 {
        font-size:22pt;
        color: #0837ae;
        font-weight: bold;
    }

    #signInModalBodyTopic > #smallText {
        font-size:10  pt;
        color: #A5A6B3;
        margin-bottom: 20px;
    }

    .signInFormField{
        /*margin-bottom: 30px;*/
    }
    .block{
        cursor:grab
   }
</style>
